//待认领到款信息管理
import { contractApi } from "@/axios";
//获取待认领到款信息
export function getPendingPaymentPage(params, sendData) {
    return contractApi({
        url: '/pending-payment-info/page',
        method: 'post',
        data: sendData,
        params: params
    })
}
//添加待认领到款信息
export function addPendingPayment(data) {
    return contractApi({
        url: '/pending-payment-info',
        method: 'post',
        data: data
    })
}
//修改待认领到款信息
export function editPendingPayment(data) {
    return contractApi({
        url: '/pending-payment-info',
        method: 'put',
        data: data
    })
}
//认领到款（选择认领发票或合同）
export function claimPendingPayment(data) {
    return contractApi({
        url: '/pending-payment-info/claim',
        method: 'put',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//删除待认领待认领到款
export function deletePendingPayment(params) {
    return contractApi({
        url: '/pending-payment-info',
        method: 'delete',
        params: params
    })
}